import { Link } from "react-router-dom";

export function NotFound(){
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold text-slate-200">404 — Page not found</h1>
      <p className="text-slate-400">
        The page you&apos;re looking for doesn&apos;t exist.
      </p>
      <Link to="/" className="text-indigo-400 underline">
        Go home
      </Link>
    </div>
  );
}
